export default __webpack_public_path__ + "static/media/ic-invoice.c28d7805.svg";